import validate from "/usr/src/app/content/n3-packages-0978c6ad-2e17-4fbd-b15b-382e3e986b13/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-0978c6ad-2e17-4fbd-b15b-382e3e986b13/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}